import jsPDF, { jsPDFAPI } from "jspdf";
import { BasePDFNode, getYoga, RectPDFNode, TextPDFNode } from "./BasePDFNode";
import { RangedKanaal, RangedKanaalAssign } from "../props/PropTypes";
import { HdwLayout, Kaart } from "../kanaal/hdw-config/HdwSysteem";
import { getAssignment, kanaalLabelHdw } from "../kanaal/kanaal.utils";
import { DipSwitch, IOLine, JumperNode } from "./KaartPartsNodes";
import { isSysteemKaart } from "../kanaal/hdw-config/hdw-konfig-types";

export class KaartPDFNode extends RectPDFNode {
    constructor(public pdf: jsPDF, public kanaalMap: Record<string, Array<Array<RangedKanaalAssign>>>, public kaart: Kaart, public rotated: boolean = false) {
        super(pdf, {
            flexDirection: rotated ? 'row-reverse' : 'row',
            justifyContent: "space-between",
            // margin: 1,
            padding: 1,
            width: 140,
            maxWidth: 140,
            // fillColor: '#E0E000',
            // borderColor: '#E00000'

        }, getYoga().Node.create());

    }

    public init(): void {

        let container = this.addChild2(new IOKlemPDFNode(this.pdf, this.kanaalMap, this.kaart.getHdwLayout(), false, this.rotated));
        let right = this.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'column',
            rowGap: 3
        }));
        let txt = right.addChild2(new TextPDFNode(this.pdf, {
            fontSize: 10

        }));
        txt.text = `Pos ${this.kaart.number} - ${this.kaart.type.label}`;
        if (this.kaart.type.bus == 'fastlink') {
            right.addChild2(new BasePDFNode(this.pdf, {
                flexDirection: 'row',
            }))
                .addChild2(new DipSwitch(this.pdf, this.kaart.dipSwitch, this.kaart.type.maxDipSwitchBits, this.rotated ? "up" : "down"));
        } else {
            let hasDipSwitch = true;
            if (isSysteemKaart(this.kaart.type) && this.kaart.type.noDipSwitch == true) {
                hasDipSwitch = false;
            }
            if (hasDipSwitch) {
                right.addChild2(new DipSwitch(this.pdf, this.kaart.dipSwitch, this.kaart.type.maxDipSwitchBits));
            }
        }

        super.init();

    }
}

export class FastlinkXTPDFNode extends RectPDFNode {
    constructor(public pdf: jsPDF, public kanaalMap: Record<string, Array<Array<RangedKanaalAssign>>>, public kaart: Kaart,
        public main: boolean, public secondDip: number, public rotated: boolean = true, public lastVeldStation: boolean = false) {
        super(pdf, {
            flexDirection: rotated ? 'row-reverse' : 'row',
            justifyContent: "space-between",
            padding: 1,
            width: 140,
            maxWidth: 140,
            // fillColor: '#E0E000',
            // borderColor: '#E00000'

        }, getYoga().Node.create());

    }

    public init(): void {
        let container = this.addChild2(new IOKlemPDFNode(this.pdf, this.kanaalMap, this.kaart.getHdwLayout(), false, this.rotated));
        container.style.maxWidth = 50;
        let right = this.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'column',
            justifyContent: this.rotated ? "flex-start" : "space-between",
            marginBottom: 10,
            rowGap: 3
        }));
        let txt = right.addChild2(new TextPDFNode(this.pdf, {
            fontSize: 10

        }));
        txt.text = `Pos ${this.kaart.number} - ${this.kaart.type.label} ${this.lastVeldStation ? '(*)' : ''}`;
        let tmp = right.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: this.rotated ? 'column' : 'column-reverse',
            justifyContent: "space-between",
            height: 80,
            rowGap: 20
        }));
        let dsc = tmp.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: this.rotated ? 'row' : 'row-reverse',
            justifyContent: "space-between",
            height: 40,
            columnGap: 20
        }));
        let dp1 = dsc.addChild2(new DipSwitch(this.pdf, this.kaart.dipSwitch, this.kaart.type.maxDipSwitchBits, this.rotated ? "up" : "down"));
        dp1.style.alignSelf = this.rotated ? 'flex-start' : 'flex-end';
        let dp = dsc.addChild2(new DipSwitch(this.pdf, this.secondDip, 4, this.rotated ? "right" : "left", { numbers: '#cc70c9', on: "70cc70" }));
        dp.style.alignSelf = this.rotated ? 'flex-end' : 'flex-start';
        let jumper = tmp.addChild2(new JumperNode(this.pdf, ["J1","2", "1"], this.rotated ? "right" : "left", this.lastVeldStation ? 1 : 0));
        jumper.style.alignSelf = this.rotated ? 'flex-start' : 'flex-end';
        // let txt2 = tmp.addChild2(new TextPDFNode(this.pdf, {
        //     fontSize: 10
        // }));
        // txt2.text = this.lastVeldStation ? '1 - 2' : 'J1 - 1'
        // txt2.style.alignSelf = this.rotated ? 'flex-start' : 'flex-end';

        super.init();
    }
}


export function measureKlem(hdwLayout: HdwLayout[], kanaalMap: Record<string, Array<Array<RangedKanaalAssign>>>) {
    let ret = 0;
    for (let slot of hdwLayout) {
        if (slot.kanaal != undefined) {
            let ac = getAssignment(slot.kanaal.ioType, slot.kanaal.start, kanaalMap);
            ret = ret + Math.max(ac.length, 1);
        } else {
            ret = ret + 1;
        }

    }
    return ret;
}

export class IOKlemPDFNode extends RectPDFNode {

    constructor(public pdf: jsPDF, public kanaalMap: Record<string, Array<Array<RangedKanaalAssign>>>, public hdwLayout: HdwLayout[],
        public drawBorder: boolean = false, public rotated: boolean = false) {

        super(pdf, {
            flexDirection: rotated ? 'column-reverse' : 'column',
            // fillColor: '#E0E000',
            // borderColor: '#E00000'

        }, getYoga().Node.create());
        if (!drawBorder) {
            this.rectStyle.borderColor = undefined;
        }

    }

    public init(): void {
        let aStart = undefined;
        let cell;
        for (let slot of this.hdwLayout) {
            if (slot.kanaal != undefined) {
                let ac = getAssignment(slot.kanaal.ioType, slot.kanaal.start, this.kanaalMap);
                let b = slot.slotName;
                let a = "";
                if (b != 'a') {
                    let parts = b.split(':');
                    a = parts[0];
                    b = parts[1];
                    if (aStart != a) {
                        aStart = a;
                    } else {
                        a = "";
                    }
                }
                cell = this.addChild2(new IOLine(this.pdf, ac, a, b, false, this.rotated));
                if (this.style.maxWidth != undefined) {
                    cell.style.maxWidth = this.style.maxWidth;
                }
            } else {
                cell = this.addChild2(new IOLine(this.pdf, [], "", slot.slotName, true, this.rotated));
                if (this.style.maxWidth != undefined) {
                    cell.style.maxWidth = this.style.maxWidth;
                }
            }

        }
        // if (cell != undefined) {
        //     cell.style.marginBottom = 1;
        // }
        super.init();

    }

}
